import { ToastProvider } from "@fanka/ui-admin";
import { STATIC_ROUTES } from "@on-site/constants/routes";
import { Route, Router, Switch } from "@on-site/libs/router";
import { NotFoundPage } from "@on-site/pages/404";
import { TopPage } from "@on-site/pages/top";

function App() {
  return (
    <ToastProvider>
      <Router>
        <Switch>
          <Route path={STATIC_ROUTES.CLINIC_TOP} element={<TopPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Switch>
      </Router>
    </ToastProvider>
  );
}

export default App;
